import { render, staticRenderFns } from "./SubjectViewUserPermissionsCard.vue?vue&type=template&id=1cd70c82&"
import script from "./SubjectViewUserPermissionsCard.vue?vue&type=script&lang=js&"
export * from "./SubjectViewUserPermissionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports